import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import './ScrollBar.scss'

export default class extends React.Component {

  render () {
    return (

      <PerfectScrollbar
        style={Object.assign({
          height: this.props.height || this.props.maxHeight,
          maxHeight:  this.props.maxHeight,
        }, this.props.style || {})} className={this.props.className || ''}
        onScrollY={_ => {
          $('.ps__rail-y').css('display', 'block')
          this.setState({
            typingTimeout: setTimeout(_ => {
              $('.ps__rail-y').css('display', 'none')
            }, 1200)
          }, this.forceUpdate)
        }}>
        {
          this.props.children
        }
      </PerfectScrollbar>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Components/ScrollBar.js